import React, { useEffect, useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { ValidateFields } from 'rc-field-form/es/interface';
import { useTranslation } from 'react-i18next';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeStopListSyncIntervalMinutes: (value: Nullable<number>) => void;
	revalidateForm: ValidateFields;
	useCustomerStopListSyncInterval: boolean;
}

export const StopListSyncIntervalField: React.FC<IProps> = React.memo(
	({ changeStopListSyncIntervalMinutes, revalidateForm, useCustomerStopListSyncInterval }) => {
		const { t } = useTranslation('error');

		const validationRules = useMemo<Rule[]>(
			() => [{ required: !useCustomerStopListSyncInterval, message: t('enterStopListSyncInterval') }],
			[t, useCustomerStopListSyncInterval],
		);

		useEffect(() => {
			if (useCustomerStopListSyncInterval) {
				revalidateForm(['stopListSyncIntervalMinutes']).catch(() => undefined);
			}
		}, [useCustomerStopListSyncInterval, revalidateForm]);

		return (
			<FormInput
				testId="StopListSyncIntervalField"
				type="number"
				min={5}
				max={600}
				precision={0}
				name="stopListSyncIntervalMinutes"
				label="stopListSyncIntervalLabel"
				placeholder="stopListSyncIntervalPlaceholder"
				disabled={useCustomerStopListSyncInterval}
				onChangeNumber={changeStopListSyncIntervalMinutes}
				validationRules={validationRules}
			/>
		);
	},
);
